// extracted by mini-css-extract-plugin
export var block = "language-switcher-module--block--39txx";
export var active = "language-switcher-module--active--2KrZO";
export var activeTrail = "language-switcher-module--activeTrail--2BHO6";